import React, { useRef, useEffect, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { createPopper } from '@popperjs/core';
import Header from './components/common-header/Header';
import Hero from './components/Hero/Hero';
import Footer from './components/common-footer/Footer';
import './App.scss';
import Chapter1 from './components/Chapters/Chapter1';
import Chapter2 from './components/Chapters/Chapter2';
import Chapter3 from './components/Chapters/Chapter3';
import Chapter4 from './components/Chapters/Chapter4';
import Chapter5 from './components/Chapters/Chapter5';
import Chapter6 from './components/Chapters/Chapter6';
import Sidebar from './components/Chapters/Sidebar';
import InlinePhoto from './components/InlinePhotos/InlinePhoto';
import Quotes from './components/Quotes/Quotes';
import CTA from './components/CTA/CTA';
import Infographic from './components/Infographic/Infographic';

gsap.registerPlugin(ScrollTrigger);

function App() {
  const headerRef = useRef();
  const inline1 = useRef();
  const inline2 = useRef();
  const inline3 = useRef();
  const appRef = useRef();
  const allPhotosRef = useRef();
  allPhotosRef.current = [inline1, inline2, inline3]; // put all photo refs in this array
  const [width, setWidth] = useState(window.innerWidth);

  //creates/shows tooltip element when mouse enters
  const handleMouseEnterTooltip = (e, currentRef) => {
    const content = currentRef.current;
    createPopper(e.target, content, {
      placement: 'bottom',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 5]
          }
        }
      ]
    });
    content.style.visibility = 'visible';
  };

  //hides tooltip element when mouse leaves
  const handleMouseLeaveTooltip = (currentRef) => {
    currentRef.current.style.visibility = 'hidden';
  };

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      const currentWidth = entries[0].contentRect.width;

      if (currentWidth !== width) {
        setWidth(currentWidth);
      }
    });
    resizeObserver.observe(appRef.current);
  }, [width]);

  // useEffect(() => {
  //   const sections = [section1, section2]; //put all ref for sections in the array in order
  //   sections.forEach((panel) => {
  //     ScrollTrigger.create({
  //       trigger: panel.current,
  //       start: 'bottom bottom',
  //       pin: panel.current,
  //       pinSpacing: false
  //     });
  //   });
  // }, []);

  //adds scale animation to inline photos
  useEffect(() => {
    allPhotosRef.current.forEach((photo) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: photo.current,
          start: '20% bottom',
          end: 'top center',
          scrub: 1
        }
      });
      tl.to(photo.current, {
        width: '100%',
        height: '100%',
        duration: 3
      });
    });
  }, []);
  return (
    <div className="app" ref={appRef}>
      <Header headerRef={headerRef} />
      <Hero
        handleMouseEnterTooltip={handleMouseEnterTooltip}
        handleMouseLeaveTooltip={handleMouseLeaveTooltip}
        width={width}
      />
      <h2 className="chapter app__subHead">
        New immunotherapy treatments for cancer called autologous CAR T promised to revolutionize
        treatment for thousands of patients who were out of options. But with nearly half of
        eligible patients unable to receive treatment due to supply bottlenecks, a first-of-its-kind
        alliance of doctors is investigating a new kind of CAR T—one that can be made faster and
        potentially treat more people who need it.
      </h2>
      <Chapter1 />
      <InlinePhoto width={width} photoSize="fullBleed" photoRef={inline1} index={0} />
      <Chapter2 />
      <Quotes index={0} />
      <Chapter3 />
      <Infographic width={width} />
      <InlinePhoto width={width} photoSize="contentWidth" photoRef={inline2} index={0} />
      <Chapter4 />
      <Quotes index={1} />
      <InlinePhoto width={width} photoSize="fullBleed" photoRef={inline3} index={1} />
      <Chapter5 />
      <Quotes index={2} />
      <Chapter6 />
      <Sidebar width={width} />
      <CTA width={width} />
      <Footer />
    </div>
  );
}

export default App;
